import { Chip } from '@mui/material'
import type { LessonPaymentStatus } from '@/types/billing'
import { useTranslation } from 'react-i18next'

function statusColor(status: LessonPaymentStatus): 'default' | 'warning' | 'success' | 'info' {
  switch (status) {
    case 'pending':
      return 'warning'
    case 'paid':
      return 'success'
    case 'deferred':
      return 'info'
    default:
      return 'default'
  }
}

export function PaymentStatusChip({ status }: { status?: LessonPaymentStatus | null }) {
  const { t } = useTranslation()
  if (!status) return null
  return (
    <Chip
      size="small"
      color={statusColor(status)}
      label={t(`billing.paymentStatus.${status}`, status)}
    />
  )
}
